/**
 * Created by Daniela on 26/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { abastecimentosModuleName } from "../shared/data.service";

@Component({
    template: require('./abastecimento-relatorio.component.html')
})
export class AbastecimentoRelatorioComponent implements OnInit {
    module: any = abastecimentosModuleName;

    constructor() { }

    ngOnInit() {
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/relatorios/abastecimento-relatorio.component.ts
 **/